import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import OfferListLoadingOfferTile from 'components/OfferList/OfferListTiles/OfferListLoadingOfferTile'

const OfferListWrapper = styled(LayoutContainer)`
  ${mediaQueryUp.desktop} {
    && {
      max-width: ${rem(1352)};
    }
  }
`

const DealPageHeroSkeleton = styled(LoadingBox)`
  width: 100%;
  height: ${rem(300)};
`

const DealPageSidebarFiltersSkeleton = styled(LoadingBox)`
  max-width: ${rem(250)};
  aspect-ratio: 1 / 1;
  display: none;

  ${mediaQueryUp.tablet} {
    display: block;
  }
`

function CruiseDealSkeleton() {
  return <Group direction="vertical" gap={28}>
    <DealPageHeroSkeleton />

    <OfferListWrapper>
      <Group direction="horizontal" gap={28} horizontalAlign="stretch">
        <DealPageSidebarFiltersSkeleton />

        <Group direction="vertical" horizontalAlign="stretch" gap={16}>
          <OfferListLoadingOfferTile tileStyle="search" />
          <OfferListLoadingOfferTile tileStyle="search" />
          <OfferListLoadingOfferTile tileStyle="search" />
        </Group>
      </Group>
    </OfferListWrapper>
  </Group>
}

export default CruiseDealSkeleton
